import keymirror from 'keymirror';
import { AsyncRequest } from 'angieslist-app-platform';

export default keymirror({
  MARK_MODAL_SEEN: null,
  SEND_HOME_PAGE_VISIT_EVENT: null,
  ...AsyncRequest.createActionKeys('GET_ALL_HIGHLIGHTS'),
  ...AsyncRequest.createActionKeys('UPDATE_BUSINESS_HIGHLIGHTS'),
});



// WEBPACK FOOTER //
// ./src/modules/home/common/homeActionKeys.js